import { render, staticRenderFns } from "./TaskUploadModal.vue?vue&type=template&id=e10c4f30"
import script from "./TaskUploadModal.vue?vue&type=script&lang=js"
export * from "./TaskUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports